module.exports = __webpack_public_path__ + "img/p20.df94c2ae.png";